import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import api from "@/lib/api";

const inp = "rounded-lg bg-chessup-deep border border-chessup-border px-3 py-2 text-sm text-chessup-text focus:border-chessup-turq focus:outline-none w-full";

export default function AdminSettings() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings").then(({ data }) => setS({ price_amount: 9990, price_currency: "brl", plan_name: "ChessUp Academy Premium", ...data })).catch(() => {}); }, []);
  if (!s) return <div className="p-8" />;

  const save = async () => {
    await api.put("/admin/settings", {
      whatsapp_number: s.whatsapp_number, whatsapp_message: s.whatsapp_message,
      price_amount: parseInt(s.price_amount), price_currency: s.price_currency, plan_name: s.plan_name,
    });
    toast.success("Configurações salvas");
  };

  return (
    <div className="p-5 sm:p-8 max-w-xl">
      <h1 className="font-heading text-3xl text-chessup-text mb-6">Configurações</h1>
      <div className="rounded-xl border border-chessup-border bg-chessup-card p-6 space-y-4">
        <div><label className="text-xs text-chessup-subtext">Número do WhatsApp (com DDI)</label><input className={`${inp} mt-1`} value={s.whatsapp_number || ""} onChange={(e) => setS({ ...s, whatsapp_number: e.target.value })} data-testid="settings-whatsapp-number" /></div>
        <div><label className="text-xs text-chessup-subtext">Mensagem padrão do WhatsApp</label><textarea rows={3} className={`${inp} mt-1`} value={s.whatsapp_message || ""} onChange={(e) => setS({ ...s, whatsapp_message: e.target.value })} /></div>
        <div><label className="text-xs text-chessup-subtext">Nome do plano</label><input className={`${inp} mt-1`} value={s.plan_name || ""} onChange={(e) => setS({ ...s, plan_name: e.target.value })} /></div>
        <div className="grid grid-cols-2 gap-3">
          <div><label className="text-xs text-chessup-subtext">Preço (em centavos)</label><input type="number" className={`${inp} mt-1`} value={s.price_amount} onChange={(e) => setS({ ...s, price_amount: e.target.value })} data-testid="settings-price" /></div>
          <div><label className="text-xs text-chessup-subtext">Moeda</label><input className={`${inp} mt-1`} value={s.price_currency} onChange={(e) => setS({ ...s, price_currency: e.target.value })} /></div>
        </div>
        <p className="text-xs text-chessup-subtext">O preço exibido é gerenciado aqui. O valor cobrado é definido pelo Stripe (fonte da verdade).</p>
        <button onClick={save} data-testid="settings-save" className="inline-flex items-center gap-1.5 rounded-full bg-chessup-gold px-5 py-2.5 text-sm font-semibold text-chessup-deep"><Save className="h-4 w-4" /> Salvar</button>
      </div>
    </div>
  );
}
